import React from "react";
import { Box, FormHelperText, FormLabel, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { DIAS } from "../../consts";

/**
 * Los días en que aplica un rango, como botones de dos estados.
 *
 * Estaba copiado tres veces —alta, edición y baja—, cada una con su `sx` de 20
 * líneas. Acá va una sola vez, y el `soloLectura` cubre el caso de la baja, que
 * muestra los días pero no deja tocarlos.
 *
 * La baja ya no lo usa —muestra solo horario y franja— pero `soloLectura` se deja:
 * cuesta cuatro líneas y es lo que hace falta el día que un detalle quiera mostrar
 * los días sin dejar editarlos.
 *
 * El seleccionado usa `--btn-primary-bg` (index.css), la fuente única de la
 * identidad. Venía en `#FF6D00`, que es el naranja de MIA Key: las vistas se
 * copiaron de ahí y el color se vino puesto.
 */

/**
 * El aire de abajo, que no es decorativo.
 *
 * Los `FormikInputs` siempre mandan un `helperText` de `" "` para que MUI dibuje el
 * renglón del error aunque no haya error. Ese renglón es el ritmo vertical de los
 * formularios del módulo, y por eso los Grid van con `rowSpacing={0}`.
 *
 * Este componente no es un FormikInput y no reserva nada, así que terminaba pegado a
 * la fila de Entrada/Salida. Son los ~20px del helper (0.75rem × 1.66) más los 3px de
 * margen que MUI le pone encima.
 *
 * Cuando SÍ hay un `helperText`, el renglón lo ocupa el texto de verdad y este margen
 * sobra: sumarlos daba el doble de aire que cualquier otro campo.
 */
const ALTO_RENGLON_HELPER = "23px";

export default function SelectorDias({
    value = [],
    onChange,
    soloLectura = false,
    helperText,
}) {
    const estilos = {
        flexWrap: "wrap",
        gap: "6px",
        width: "100%",
        "& .MuiToggleButton-root": {
            // Los siete se reparten el ancho del grupo. Quedan grandes para decir
            // "Lu", pero son el area de click y asi la fila entera se lee pareja.
            flex: 1,
            padding: "8px 12px",
            fontSize: "0.95rem",
            fontFamily: "inherit",
            textTransform: "none",
            border: "1px solid rgba(0,0,0,0.23) !important",
            borderRadius: "4px !important",
            color: "rgba(0,0,0,0.6)",
            ...(soloLectura && { cursor: "default" }),
        },
        "& .MuiToggleButton-root.Mui-selected": {
            backgroundColor: "var(--btn-primary-bg)",
            color: "#ffffff",
            borderColor: "var(--btn-primary-bg) !important",
            ...(!soloLectura && {
                "&:hover": { backgroundColor: "var(--btn-primary-bg-hover)" },
            }),
        },
    };

    return (
        <Box
            display="flex"
            flexDirection="column"
            gap="4px"
            width="100%"
            // `.paper` del Modal centra TODO su contenido, y la etiqueta "Dias" lo
            // heredaba: quedaba centrada sobre los botones mientras el resto de las
            // etiquetas del formulario van a la izquierda.
            textAlign="left"
            // Con ayuda visible el renglon lo ocupa el texto, pero igual hace falta
            // separacion: sin esto quedaba pegado a la fila de Entrada/Salida.
            marginBottom={helperText ? "8px" : ALTO_RENGLON_HELPER}
        >
            <FormLabel>Días</FormLabel>
            <ToggleButtonGroup
                value={value}
                onChange={soloLectura ? undefined : onChange}
                aria-label="días de la semana"
                sx={estilos}
            >
                {DIAS.map(({ cod, label }) => (
                    <ToggleButton
                        key={cod}
                        value={cod}
                        aria-label={label}
                        // En solo lectura el grupo no maneja el estado, así que cada
                        // botón dice si está marcado por su cuenta.
                        {...(soloLectura && {
                            selected: value.includes(cod),
                            onClick: (e) => e.preventDefault(),
                            disableRipple: true,
                        })}
                    >
                        {label}
                    </ToggleButton>
                ))}
            </ToggleButtonGroup>
            {/* Gris y no rojo: el campo arranca vacio en el alta, asi que pintarlo
                de error seria retar al usuario antes de que haga nada. Lo que impide
                guardar es el boton apagado; esto solo dice por que. */}
            {helperText && <FormHelperText>{helperText}</FormHelperText>}
        </Box>
    );
}
